export default "/images/contest1.jpg?a87d83675a5eda754ccb5330f76a4da4";